import script from "./OnboardingImport.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingImport.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingImport.vue?vue&type=style&index=0&id=e02dee30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e02dee30"]])

export default __exports__